import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

//import {
//    nvl,
//} from '../../../business-components/Formata/Formata'

import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem4,
    GridItem6,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonDuplicar,
    ButtonCalcular,
    ButtonConfiguracao,
    ButtonVisualizarResumo,
    ButtonVisualizarIncluirComparacaoFinanciamento,
    //ButtonVisualizarIncluirComparacaoFinanciamentoDisabled,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import administradoraConsorcioList from '../../../business-rules/List/Consorcio/administradoraConsorcioList'

import tipoFinanciamentoList from '../../../business-rules/List/tipoFinanciamentoList'

import {
    processaCalculoConsorcioSimulacaoItem,
    incluirAtualizarFinanciamento,
} from './ConsorcioServiceSimulacaoItem'

import {
    ConsorcioSimulacaoInputList,
    ConsorcioSimulacaoInputListValor,
    ConsorcioSimulacaoInputText,
    ConsorcioSimulacaoInputValor,
    ConsorcioSimulacaoListInputPerc,
    ConsorcioSimulacaoInputNumero,
    ConsorcioSimulacaoInputPerc,
    ConsorcioSimulacaoInputCheckboxMeses,
    ConsorcioSimulacaoInputMesAnoPerc,
    ConsorcioSimulacaoExibeValor,
    ConsorcioSimulacaoExibeNumeroValor,
    ConsorcioSimulacaoExibePerc,
    ConsorcioSimulacaoExibePercValor,
    ConsorcioSimulacaoAdministradoraConsorcio,
    ConsorcioSimulacaoGrupoConsorcio,
    ConsorcioSimulacaoPessoaFisicaJuridica,
    ConsorcioSimulacaoValorCreditoConsorcio,
    ConsorcioSimulacaoValorUpGradeCreditoConsorcio,
    ConsorcioSimulacaoPrazoTotalGrupoConsorcio,
    ConsorcioSimulacaoPrazoOriginalGrupoConsorcio,
    ConsorcioSimulacaoParcelasAdesao,
    ConsorcioSimulacaoPercLanceRecursosProprios,
    ConsorcioSimulacaoValorLanceRecursosPropriosInformado,
    ConsorcioSimulacaoPercLanceEmbutido,
    ConsorcioSimulacaoValorLanceEmbutidoInformado,
    ConsorcioSimulacaoPercLanceIntegrado,
    ConsorcioSimulacaoTipoLanceList,
    ConsorcioSimulacaoTipoLanceListPerc,
    ConsorcioSimulacaoFormaAbaterLance,
    ConsorcioSimulacaoContemplacaoParcela,
    ConsorcioSimulacaoMesAnoPrimeiroReajuste,
    ConsorcioSimulacaoTaxaAnual,
    ConsorcioSimulacaoParcelaTCV,
    //ConsorcioSimulacaoTipoGrupoConsorcio,
    ConsorcioSimulacaoTaxaAdesao,
    ConsorcioSimulacaoTaxaAdministracao,
    ConsorcioSimulacaoPercFundoReserva,
    ConsorcioSimulacaoFundoReservaSeraDevolvidoFinal,
    ConsorcioSimulacaoMesesDevolucaoFundoReserva,
    ConsorcioSimulacaoPercDevolucaoFundoReserva,
    ConsorcioSimulacaoPercSeguroPrestamista,
    ConsorcioSimulacaoPercRedutoParcela,
    ConsorcioSimulacaoAnalisarAluguelAposContemplacao,
    ConsorcioSimulacaoMesesIniciarAluguelAposContemplacao,
    ConsorcioSimulacaoPercAluguelMensalAposContemplacao,
    ConsorcioSimulacaoPercReajusteAluguelAnualAposContemplacao,
    ConsorcioSimulacaoValorImovelAluguelAposContemplacao,
    ConsorcioSimulacaoPercValorizacaoImovelAluguelAposContemplacao,
    ConsorcioSimulacaoAnalisarVendaAposQuitacao,
    ConsorcioSimulacaoMesesVendaAposQuitacao,
} from './ConsorcioCompSimulacaotem'

import DespesasFormFinanciamentoItem from '../despesas-form/DespesasFormFinanciamentoItem'

import ConsorcioFormSimulacaoItemReport from './ConsorcioFormSimulacaoItemReport'



const DespesasFormFinanciamentoItemConsorcio = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    linhaTipoLicenca, item }) => {
    
    const [ind, setInd] = useState(null)

    useSingleton(async () => {

        setInd(incluirAtualizarFinanciamento(values, item))
    })

    return (
        ind || ind === 0
            ?
                <DespesasFormFinanciamentoItem
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    arrayHelpers={null}
                    linhaTipoLicenca={linhaTipoLicenca}
                    tipoFinanciamentoSelecionado={
                        pesquisaList(tipoFinanciamentoList, values.financiamento[ind].tipoFinanciamento)
                    }
                    item={values.financiamento[ind]}
                    ind={ind}
                    simplificado={true}
                />
            :
                ''
    )
}

const ConsorcioFormSimulacaoItem = ({ variaveisGlobais, values, item, ind, handleChange, handleSubmit, setFieldValue,
    arrayHelpers, linhaTipoLicenca, report, pagina }) => {
    
    const linhaInstituicaoFinanceira =
        item.administradoraConsorcio
            ?
                pesquisaList(administradoraConsorcioList(true), item.administradoraConsorcio)
            :
                null

    const SvgConsorcioLogoInstituicaoFinanceira =
        linhaInstituicaoFinanceira && linhaInstituicaoFinanceira.SvgConsorcioLogo
            ?
                linhaInstituicaoFinanceira.SvgConsorcioLogo
            :
                ''
        
    processaCalculoConsorcioSimulacaoItem(values, item, linhaInstituicaoFinanceira)

    const params = {
        item: item,
        ind: ind,
        handleChange: handleChange,
        linhaInstituicaoFinanceira: linhaInstituicaoFinanceira,
        SvgConsorcioLogoInstituicaoFinanceira: SvgConsorcioLogoInstituicaoFinanceira,
        report: report,
    }

    const GridItemConsorcioSimulacaoItem = report ? GridItem12 : GridItem6 
    const CardGridEntradaDadosConsorcioSimulacaoItem = report ? GridItem12 : CardGridEntradaDados
    const classNameCardGridEntradaDadosConsorcioSimulacaoItem1 = report ? 'mt-5' : ''
    const classNameCardGridEntradaDadosConsorcioSimulacaoItem2 = report ? 'mt-10' : ''

    return (
        <GridContainer
            className={report ? 'mt--5' : 'mt-5 mb-5'}
        >
            {!report && (
                <GridContainer>
                    <GridItem12>
                        <CardGridEntradaDados>
                            <CardGridDivBody>
                                <GridContainer>
                                    <GridItem4>
                                        <GridContainer
                                            className='justify-start ml-7 mt-4 mb-2'
                                        >
                                            {SvgConsorcioLogoInstituicaoFinanceira && !item.naoExibirLogo && (
                                                <div
                                                    //className={'ml--' + linhaInstituicaoFinanceira.svgConsorcioLogoMl}
                                                >
                                                    <SvgConsorcioLogoInstituicaoFinanceira/>
                                                </div>
                                            )}
                                        </GridContainer>
                                    </GridItem4>

                                    <GridItem2>
                                        <CustomizedDialogsPopup
                                            maxWidth='md'
                                            popupTitle={LABEL.configuracao}
                                            PopupButton={ButtonConfiguracao}
                                            popupComponent={
                                                <GridContainer>
                                                    <GridItem12>
                                                        <CheckboxPadrao
                                                            name={`objConsorcio.simulacao[${ind}].calcularTaxaMensalAnualResumoComBaseCreditoLiberado`}
                                                            label={LABEL.calcularTaxaMensalAnualResumoComBaseCreditoLiberado}
                                                            checked={item.calcularTaxaMensalAnualResumoComBaseCreditoLiberado}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem12>

                                                    <GridItem12>
                                                        <CheckboxPadrao
                                                            name={`objConsorcio.simulacao[${ind}].naoExibirLogo`}
                                                            label={LABEL.naoExibirLogo}
                                                            checked={item.naoExibirLogo}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem12>

                                                    <GridItem12>
                                                        <CheckboxPadrao
                                                            name={`objConsorcio.simulacao[${ind}].naoExibirRelatorio`}
                                                            label={LABEL.naoExibirRelatorio}
                                                            checked={item.naoExibirRelatorio}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem12>
                                                </GridContainer>
                                            }
                                        />
                                    </GridItem2>

                                    <GridItem6>
                                        <GridContainer>
                                            <GridItem4>
                                                <CustomizedDialogsPopup
                                                    maxWidth='md'
                                                    popupTitle={LABEL.resumo}
                                                    PopupButton={ButtonVisualizarResumo}
                                                    popupComponent={
                                                        <ConsorcioFormSimulacaoItemReport
                                                            values={values}
                                                            item={item}
                                                            report={false}
                                                        />
                                                    }
                                                />
                                            </GridItem4>

                                            <GridItem4>
                                                {item.valorParcelaInicial > 0 && item.valorParcelaAposComtemplacao > 0 && (
                                                    <CustomizedDialogsPopup
                                                        maxWidth='sm'
                                                        popupTitle={LABEL.consorcio}
                                                        PopupButton={ButtonVisualizarIncluirComparacaoFinanciamento}
                                                        //    item.idFinanciamento &&
                                                        //        pesquisaList(values.financiamento, item.idFinanciamento).id
                                                        //        ?
                                                        //            ButtonVisualizarIncluirComparacaoFinanciamentoDisabled
                                                        //        :
                                                        //            ButtonVisualizarIncluirComparacaoFinanciamento
                                                        //}
                                                        popupButtonDestaque={false}
                                                        DialogContentClassName={CLASSNAME().dialogContentClassNameFormExpandir}
                                                        popupComponent={
                                                            <DespesasFormFinanciamentoItemConsorcio
                                                                variaveisGlobais={variaveisGlobais}
                                                                values={values}
                                                                handleChange={handleChange}
                                                                handleSubmit={handleSubmit}
                                                                setFieldValue={setFieldValue}
                                                                linhaTipoLicenca={linhaTipoLicenca}
                                                                item={item}
                                                            />
                                                        }
                                                        open={() => values.naoIncluirAtualizarFinanciamento = true}
                                                        afterClose={() => values.naoIncluirAtualizarFinanciamento = false}
                                                        disabled={item.idFinanciamento &&
                                                            pesquisaList(values.financiamento, item.idFinanciamento).id
                                                        }
                                                    />
                                                )}
                                            </GridItem4>

                                            <GridItem3>
                                                {arrayHelpers && (
                                                    <ButtonDuplicar
                                                        onClick={() => {
                                                            arrayHelpers.push({
                                                                ...item,
                                                                idFinanciamento: '',
                                                            })
                                                        }}
                                                    />
                                                )}
                                            </GridItem3>

                                            <GridItem1
                                                align='rigth'
                                                className='mt-6'
                                            >
                                                {!report && arrayHelpers && (
                                                    <IconButtonClearEntradaDados
                                                        onClick={() =>
                                                            arrayHelpers.remove(ind)
                                                        }
                                                    />
                                                )}
                                            </GridItem1>
                                        </GridContainer>
                                    </GridItem6>
                                </GridContainer>
                            </CardGridDivBody>
                        </CardGridEntradaDados>
                    </GridItem12>
                </GridContainer>
            )}

            <GridItemConsorcioSimulacaoItem>
                <GridContainer
                    className='justify-center'
                >
                    <GridItem11>
                        {(!report || values.modoApresentacao || pagina === 1) && (
                            <CardGridEntradaDadosConsorcioSimulacaoItem
                                className={classNameCardGridEntradaDadosConsorcioSimulacaoItem1}
                            >
                                <CardGridEntradaDadosHeaderBody
                                    title={LABEL.credito}
                                >
                                    <ConsorcioSimulacaoInputList
                                        label={LABEL.administradoraConsorcio}
                                        Componente={ConsorcioSimulacaoAdministradoraConsorcio}
                                        params={params}
                                        naoExibirLabelReport={true}
                                    />

                                    <ConsorcioSimulacaoInputText
                                        label={LABEL.grupoConsorcio}
                                        Componente={ConsorcioSimulacaoGrupoConsorcio}
                                        params={params}
                                    />

                                    {item.administradoraConsorcio && (
                                        <>
                                            <ConsorcioSimulacaoInputList
                                                label={LABEL.pessoaFisicaJuridica}
                                                Componente={ConsorcioSimulacaoPessoaFisicaJuridica}
                                                params={params}
                                            />

                                            <ConsorcioSimulacaoInputValor
                                                label={LABEL.valorCreditoConsorcio}
                                                Componente={ConsorcioSimulacaoValorCreditoConsorcio}
                                                params={params}
                                            />

                                            {item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraMAPFRE && (
                                                <ConsorcioSimulacaoInputValor
                                                    label={LABEL.valorUpGradeCreditoConsorcio}
                                                    Componente={ConsorcioSimulacaoValorUpGradeCreditoConsorcio}
                                                    params={params}
                                                    perc={item.percValorUpGradeCreditoConsorcio}
                                                />
                                            )}

                                            <ConsorcioSimulacaoInputNumero
                                                label={LABEL.prazoAtualGrupoConsorcio}
                                                Componente={ConsorcioSimulacaoPrazoTotalGrupoConsorcio}
                                                params={params}
                                            />

                                            {item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras && (
                                                <ConsorcioSimulacaoInputNumero
                                                    label={LABEL.prazoOriginalGrupoConsorcio}
                                                    Componente={ConsorcioSimulacaoPrazoOriginalGrupoConsorcio}
                                                    params={params}
                                                />
                                            )}

                                            {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                            //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                                <>
                                                    <ConsorcioSimulacaoInputListValor
                                                        label={LABEL.adesao}
                                                        Componente={ConsorcioSimulacaoParcelasAdesao}
                                                        params={params}
                                                        list={linhaInstituicaoFinanceira.primeirasParcelasList}
                                                        valor={item.valorParcelasAdesao}
                                                    />
                                                </>
                                            )}

                                            <ConsorcioSimulacaoExibeValor
                                                label={LABEL.parcelaAteComtemplacao}
                                                params={params}
                                                valor={item.valorParcelaInicial}
                                            />
                                        </>
                                    )}
                                </CardGridEntradaDadosHeaderBody>
                            </CardGridEntradaDadosConsorcioSimulacaoItem>
                        )}

                        {(!report || values.modoApresentacao || pagina === 2) && item.administradoraConsorcio && (
                            <CardGridEntradaDadosConsorcioSimulacaoItem
                                className={classNameCardGridEntradaDadosConsorcioSimulacaoItem2}
                            >
                                <CardGridEntradaDadosHeaderBody
                                    title={LABEL.estrategiaLance}
                                >
                                    {/*
                                    <ConsorcioSimulacaoExibeValor
                                        label={LABEL.lanceTotal}
                                        params={params}
                                        valor={item.valorLanceTotal}
                                        perc={item.percLancetotal}
                                    />
                                    */}
                                    <ConsorcioSimulacaoExibePercValor
                                        label={LABEL.lanceTotal}
                                        params={params}
                                        valor={item.valorLanceTotal}
                                        perc={item.percLancetotal}
                                    />

                                    {/*
                                    <ConsorcioSimulacaoInputValor
                                        label={LABEL.lanceRecursosProprios}
                                        Componente={ConsorcioSimulacaoLanceRecursosProprios}
                                        params={params}
                                        perc={item.percLanceRecursosProprios}
                                    />
                                    */}
                                    <ConsorcioSimulacaoInputPerc
                                        label={LABEL.lanceRecursosProprios}
                                        Componente={ConsorcioSimulacaoPercLanceRecursosProprios}
                                        params={params}
                                        valor={item.lanceRecursosProprios}
                                        editar={
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraBradesco &&
                                            item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraPortoSeguro
                                        }
                                        editarPopupTitle={LABEL.cacularPercLanceRecursosProprios}
                                        EditarComponente={ConsorcioSimulacaoValorLanceRecursosPropriosInformado}
                                        EditarPopupButtonAction={ButtonCalcular}
                                        editarPopupButtonActionCondition={item.valorLanceRecursosPropriosInformado}
                                        editarPopupButtonActionOnclick={() => {
                                            setFieldValue(`objConsorcio.simulacao[${ind}].percLanceRecursosProprios`, 
                                                item.valorLanceRecursosPropriosInformado /
                                                    (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
                                                    //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
                                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander ||
                                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa
                                                        ?
                                                            item.valorSaldoDevedor
                                                        :
                                                            item.valorCreditoConsorcio
                                                    ) * 100
                                            )
                                        }}
                                    />
                                    
                                    {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAdemicon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAncora ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraCNP ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraItau ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraUne ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraXP) && (
                                        <>
                                            {/*
                                            <ConsorcioSimulacaoInputValor
                                                label={LABEL.lanceEmbutido}
                                                Componente={ConsorcioSimulacaoLanceEmbutido}
                                                params={params}
                                                perc={item.percLanceEmbutido}
                                            />
                                            */}
                                            <ConsorcioSimulacaoInputPerc
                                                label={LABEL.lanceEmbutido}
                                                Componente={ConsorcioSimulacaoPercLanceEmbutido}
                                                params={params}
                                                valor={item.lanceEmbutido}
                                                editar={item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraPortoSeguro}
                                                editarPopupTitle={LABEL.cacularPercLanceEmbutido}
                                                EditarComponente={ConsorcioSimulacaoValorLanceEmbutidoInformado}
                                                EditarPopupButtonAction={ButtonCalcular}
                                                editarPopupButtonActionCondition={item.valorLanceEmbutidoInformado}
                                                editarPopupButtonActionOnclick={() => {
                                                    setFieldValue(`objConsorcio.simulacao[${ind}].percLanceEmbutido`, 
                                                        item.valorLanceEmbutidoInformado /
                                                            (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
                                                            //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
                                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander ||
                                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa
                                                                ?
                                                                    item.valorSaldoDevedor
                                                                :
                                                                    item.valorCreditoConsorcio
                                                            ) * 100
                                                    )
                                                }}
                                            />
                                        </>
                                    )}

                                    {item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraMAPFRE && (
                                        <>
                                            {/*
                                            <ConsorcioSimulacaoInputValor
                                                label={LABEL.lanceIntegrado}
                                                Componente={ConsorcioSimulacaoLanceIntegrado}
                                                params={params}
                                                perc={item.percLanceIntegrado}
                                            />
                                            */}
                                            <ConsorcioSimulacaoInputPerc
                                                label={LABEL.lanceIntegrado}
                                                Componente={ConsorcioSimulacaoPercLanceIntegrado}
                                                params={params}
                                                valor={item.lanceIntegrado}
                                            />

                                            {/*
                                            <ConsorcioSimulacaoListInputValor
                                                ComponenteList={ConsorcioSimulacaoTipoLanceList}
                                                list={linhaInstituicaoFinanceira.tipoLanceList}
                                                Componente={ConsorcioSimulacaoTipoLanceListValor}
                                                params={params}
                                                perc={item.percTipoLanceValor}
                                            />
                                            */}
                                            <ConsorcioSimulacaoListInputPerc
                                                ComponenteList={ConsorcioSimulacaoTipoLanceList}
                                                list={linhaInstituicaoFinanceira.tipoLanceList}
                                                Componente={ConsorcioSimulacaoTipoLanceListPerc}
                                                params={params}
                                                valor={item.tipoLanceValor}
                                            />

                                            <ConsorcioSimulacaoInputList
                                                label={LABEL.formaAbaterLance}
                                                Componente={ConsorcioSimulacaoFormaAbaterLance}
                                                params={params}
                                            />

                                            <ConsorcioSimulacaoExibePerc
                                                label={LABEL.percLanceSobreCredito}
                                                perc={item.percLanceSobreCredito}
                                            />
                                            
                                            <ConsorcioSimulacaoExibePerc
                                                label={LABEL.percLanceEfetivo}
                                                perc={item.percLanceEfetivo}
                                            />
                                        </>
                                    )}
                                </CardGridEntradaDadosHeaderBody>
                            </CardGridEntradaDadosConsorcioSimulacaoItem>
                        )}
                    </GridItem11>
                </GridContainer>
            </GridItemConsorcioSimulacaoItem>
            
            <GridItemConsorcioSimulacaoItem>
                <GridContainer
                    className='justify-center'
                >
                    <GridItem11>
                        {(!report || values.modoApresentacao || pagina === 1) && item.administradoraConsorcio && (
                            <CardGridEntradaDadosConsorcioSimulacaoItem
                                className={classNameCardGridEntradaDadosConsorcioSimulacaoItem1}
                            >
                                <CardGridEntradaDadosHeaderBody
                                    title={LABEL.taxasGrupo}
                                >
                                    {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                        <ConsorcioSimulacaoInputPerc
                                            label={LABEL.taxaAdesao}
                                            Componente={ConsorcioSimulacaoTaxaAdesao}
                                            params={params}
                                            valor={item.valorTaxaAdesao}
                                        />
                                    )}

                                    <ConsorcioSimulacaoInputPerc
                                        label={LABEL.taxaAdministracao}
                                        Componente={ConsorcioSimulacaoTaxaAdministracao}
                                        params={params}
                                        valor={item.valorTaxaAdministracao}
                                    />

                                    <ConsorcioSimulacaoInputPerc
                                        label={LABEL.percFundoReserva.replace('% ', '')}
                                        Componente={ConsorcioSimulacaoPercFundoReserva}
                                        params={params}
                                        valor={item.valorFundoReserva}
                                    />

                                    <ConsorcioSimulacaoExibePercValor
                                        label={''}
                                        params={params}
                                        perc={item.taxaTotal}
                                        valor={item.valorTaxaTotal}
                                    />

                                    <ConsorcioSimulacaoInputCheckboxMeses
                                        label={LABEL.fundoReservaSeraDevolvidoFinal}
                                        Componente={ConsorcioSimulacaoFundoReservaSeraDevolvidoFinal}
                                        label2={LABEL.mesesDevolucaoFundoReserva}
                                        Componente2={ConsorcioSimulacaoMesesDevolucaoFundoReserva}
                                        exibirComponente2={item.fundoReservaSeraDevolvidoFinal}
                                        label3={LABEL.percDevolucaoFundoReserva}
                                        Componente3={ConsorcioSimulacaoPercDevolucaoFundoReserva}
                                        params={params}
                                    />

                                    {item.pessoaFisicaJuridica !== HARDCODE.idPessoaJuridica && (
                                        <ConsorcioSimulacaoInputPerc
                                            label={LABEL.percSeguroPrestamista.replace('% ', '')}
                                            Componente={ConsorcioSimulacaoPercSeguroPrestamista}
                                            params={params}
                                            valor={item.valorSeguroPrestamista}
                                        />
                                    )}

                                    {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                        <ConsorcioSimulacaoExibeValor
                                            label={LABEL.valorParcelaInicialSemRedutor}
                                            params={params}
                                            valor={item.valorParcelaInicialSemRedutor}
                                        />
                                    )}

                                    {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAdemicon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAncora ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraCNP ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraItau ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraUne ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraXP) && (
                                        <ConsorcioSimulacaoInputPerc
                                            label={LABEL.percRedutorParcela.replace('% ', '')}
                                            Componente={ConsorcioSimulacaoPercRedutoParcela}
                                            params={params}
                                            numero={item.fatorRedutorParcela}
                                        />
                                    )}

                                    {(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                        <ConsorcioSimulacaoExibeValor
                                            label={LABEL.valorEconomiaRedutorParcela}
                                            params={params}
                                            valor={item.valorEconomiaRedutorParcela}
                                        />
                                    )}
                                </CardGridEntradaDadosHeaderBody>
                            </CardGridEntradaDadosConsorcioSimulacaoItem>
                        )}

                        {(!report || values.modoApresentacao || pagina === 2) && item.administradoraConsorcio && (
                            <CardGridEntradaDadosConsorcioSimulacaoItem
                                className={classNameCardGridEntradaDadosConsorcioSimulacaoItem2}
                            >
                                <CardGridEntradaDadosHeaderBody
                                    title={LABEL.estimativaPosContemplacao}
                                >
                                    <ConsorcioSimulacaoExibeValor
                                        label={LABEL.creditoDisponivel}
                                        params={params}
                                        valor={item.valorCreditoDisponivel}
                                    />
                                    
                                    {item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraMAPFRE && (
                                        <ConsorcioSimulacaoExibeValor
                                            label={LABEL.valorSaldoDevedor}
                                            params={params}
                                            valor={item.valorSaldoDevedor/* + nvl(item.valorTaxaAdesao, 0)*/}
                                        />
                                    )}

                                    <ConsorcioSimulacaoInputNumero
                                        label={LABEL.contemplacaoParcela}
                                        Componente={ConsorcioSimulacaoContemplacaoParcela}
                                        params={params}
                                    />

                                    <ConsorcioSimulacaoInputMesAnoPerc
                                        label={LABEL.primeiroReajuste}
                                        label2={LABEL.mesAno}
                                        Componente2={ConsorcioSimulacaoMesAnoPrimeiroReajuste}
                                        exibirComponente2={true}
                                        label3={LABEL.taxaAnual}
                                        Componente3={ConsorcioSimulacaoTaxaAnual}
                                        params={params}
                                    />

                                    {item.valorCreditoConsorcioContemplacao && (
                                        <ConsorcioSimulacaoExibeValor
                                            label={LABEL.valorCreditoConsorcioContemplacao.replace('$1$',
                                                item.taxaAnualReajusteConsorcio)}
                                            params={params}
                                            valor={item.valorCreditoConsorcioContemplacao}
                                        />
                                    )}

                                    {item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraMAPFRE && (
                                        <ConsorcioSimulacaoInputNumero
                                            label={LABEL.parcelasTCV}
                                            Componente={ConsorcioSimulacaoParcelaTCV}
                                            params={params}
                                        />
                                    )}

                                    {/*
                                    <ConsorcioSimulacaoExibeNumero 
                                        label={
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa
                                                ?
                                                    LABEL.prazoRestanteAposContemplacaoReducaoParcela
                                                :
                                                    LABEL.prazoRestanteAposContemplacao
                                        }
                                        numero={item.prazoRestanteAposContemplacao}
                                    />

                                    <ConsorcioSimulacaoExibeValor
                                        label={
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa
                                                ?
                                                    LABEL.parcelaAposComtemplacaoReducaoParcela
                                                :
                                                    LABEL.parcelaAposComtemplacao
                                        }
                                        params={params}
                                        valor={item.valorParcelaAposComtemplacao}
                                    />
                                    */}

                                    {/*item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras && (
                                        <ConsorcioSimulacaoInputList
                                            label={LABEL.tipoGrupoConsorcio}
                                            Componente={ConsorcioSimulacaoTipoGrupoConsorcio}
                                            params={params}
                                        />
                                    )*/}

                                    <ConsorcioSimulacaoExibeNumeroValor 
                                        label={LABEL.parcelaAposComtemplacao}
                                        numero={item.prazoRestanteAposContemplacao}
                                        valor={item.valorParcelaAposComtemplacao}
                                    />

                                    {(//item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa) && (
                                        <>
                                            {/*
                                            <ConsorcioSimulacaoExibeNumero
                                                label={LABEL.prazoRestanteAposContemplacaoReducaoPrazo}
                                                numero={item.prazoRestanteAposContemplacaoReducaoPrazo}
                                            />

                                            <ConsorcioSimulacaoExibeValor
                                                label={LABEL.parcelaAposComtemplacaoReducaoPrazo}
                                                params={params}
                                                valor={item.parcelaAposComtemplacaoReducaoPrazo}
                                            />
                                            */}
                                            <ConsorcioSimulacaoExibeNumeroValor
                                                label={LABEL.parcelaAposComtemplacaoReducaoPrazo}
                                                numero={item.prazoRestanteAposContemplacaoReducaoPrazo}
                                                valor={item.parcelaAposComtemplacaoReducaoPrazo}
                                            />
                                        </>
                                    )}
                                    
                                    <ConsorcioSimulacaoExibeValor
                                        label={LABEL.saldoDevedorAposComtemplacao}
                                        params={params}
                                        valor={item.valorSaldoDevedorAposContemplacao}
                                    />

                                    <ConsorcioSimulacaoInputCheckboxMeses
                                        label={LABEL.analisarAluguelAposContemplacao}
                                        Componente={ConsorcioSimulacaoAnalisarAluguelAposContemplacao}
                                        label2={LABEL.mesesIniciarAluguelAposContemplacao}
                                        Componente2={ConsorcioSimulacaoMesesIniciarAluguelAposContemplacao}
                                        exibirComponente2={item.analisarAluguelAposContemplacao}
                                        label3={LABEL.percAluguelMensalAposContemplacao}
                                        Componente3={ConsorcioSimulacaoPercAluguelMensalAposContemplacao}
                                        params={params}
                                        label4={LABEL.percReajusteAluguelAnualAposContemplacao}
                                        Componente4={ConsorcioSimulacaoPercReajusteAluguelAnualAposContemplacao}
                                        label5={LABEL.percValorizacaoImovelAluguelAposContemplacao}
                                        Componente5={ConsorcioSimulacaoPercValorizacaoImovelAluguelAposContemplacao}
                                        label6={LABEL.valorImovelAluguelAposContemplacao}
                                        Componente6={ConsorcioSimulacaoValorImovelAluguelAposContemplacao}
                                    />

                                    {item.analisarAluguelAposContemplacao && (
                                        <ConsorcioSimulacaoInputCheckboxMeses
                                            label={LABEL.analisarVendaAposQuitacao}
                                            Componente={ConsorcioSimulacaoAnalisarVendaAposQuitacao}
                                            label2={LABEL.mesesVendaAposContemplacao}
                                            Componente2={ConsorcioSimulacaoMesesVendaAposQuitacao}
                                            exibirComponente2={item.analisarVendaAposQuitacao}
                                            params={params}
                                        />
                                    )}
                                </CardGridEntradaDadosHeaderBody>
                            </CardGridEntradaDadosConsorcioSimulacaoItem>
                        )}
                            
                        {/*
                        <CardGridEntradaDadosConsorcioSimulacaoItem>
                            <CardGridEntradaDadosHeaderBody
                                title={LABEL.categoria}
                            >
                            </CardGridEntradaDadosHeaderBody>
                        </CardGridEntradaDadosConsorcioSimulacaoItem>
                    
                        <CardGridEntradaDadosConsorcioSimulacaoItem>
                            <CardGridEntradaDadosHeaderBody
                                title={LABEL.lanceEmbutido}
                            >
                            </CardGridEntradaDadosHeaderBody>
                        </CardGridEntradaDadosConsorcioSimulacaoItem>

                        <CardGridEntradaDadosConsorcioSimulacaoItem>
                            <CardGridEntradaDadosHeaderBody
                                title={LABEL.lanceFixo}
                            >
                            </CardGridEntradaDadosHeaderBody>
                        </CardGridEntradaDadosConsorcioSimulacaoItem>
                        
                        <CardGridEntradaDadosConsorcioSimulacaoItem>
                            <CardGridEntradaDadosHeaderBody
                                title={LABEL.lanceLivre}
                            >
                            </CardGridEntradaDadosHeaderBody>
                        </CardGridEntradaDadosConsorcioSimulacaoItem>
                        */}
                    </GridItem11>
                </GridContainer>
            </GridItemConsorcioSimulacaoItem>
        </GridContainer>
    )
}

export default ConsorcioFormSimulacaoItem